export const environment = {
	production: true,
	baseUrl: 'https://api.zbeacon.info/prod/',
	profileImageBaseURL: 'https://ac-profile-deneme.s3.eu-central-1.amazonaws.com/',
	assetImageBaseURL: 'https://ac-asset-images.s3.eu-central-1.amazonaws.com/'
};
